import React from "react";
import { FaBoxOpen, FaMapMarkedAlt, FaClock, FaTruck } from "react-icons/fa";

const Tracking = () => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "60px 20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <FaMapMarkedAlt size={70} color="#4B6CB7" />
      <h1 style={{ marginTop: "20px", color: "#333" }}>Seguimiento de tu pedido</h1>
      <p style={{ color: "#555", marginTop: "10px", fontSize: "18px" }}>
        Tu pedido está siendo preparado. 📦
      </p>

      <div
        style={{
          marginTop: "40px",
          display: "flex",
          justifyContent: "center",
          gap: "50px",
          flexWrap: "wrap",
        }}
      >
        <div>
          <FaBoxOpen size={40} color="#4B6CB7" />
          <p>Empaquetando productos</p>
        </div>
        <div>
          <FaTruck size={40} color="#4B6CB7" />
          <p>En tránsito</p>
        </div>
        <div>
          <FaClock size={40} color="#4B6CB7" />
          <p>Entrega estimada: 2-3 días</p>
        </div>
      </div>
    </div>
  );
};

export default Tracking;
